import { render, staticRenderFns } from "./ClearFiltersIcon.vue?vue&type=template&id=18d1f4b9&scoped=true"
import script from "./ClearFiltersIcon.vue?vue&type=script&lang=js"
export * from "./ClearFiltersIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d1f4b9",
  null
  
)

export default component.exports